import ko from '@tko/build.knockout';
import _ from 'lodash';
import templateMarkup from 'raw-loader!./clear-preferences-adv-modal.html';
import '../../app/bindings/ko-bindinghandler-tokenfield';
import PreferenceService from "../../services/preference.service";
import Selectr from 'mobius1-selectr/src/selectr';
import DashboardService from '../../modules/assurance/services/dashboard.service';

function ClearPreferencesAdv(params) {
  let self = this;

  self.signals = ko.unwrap(params.signals);

  if (!_.has(self, 'signals.onShow') || !_.has(self, 'signals.onSave')) {
    throw new Error('ClearPreferencesAdv:: Missing required signals: show, save');
  }
  self.signals.onShow.add(_.bind(self.show, self));
  self.signals.onSave.add(_.bind(self.save, self));

  self.updateError = ko.observable();
  self.hasUpdateError = ko.pureComputed(function () {
    return !_.isEmpty(self.updateError());
  });

  self.fromOrgSelctr = new Selectr('#fromOrgSelector3', {
    defaultSelected: false,
    placeholder: 'Select a Org...'
  } );
  self.fromUserSelctr = new Selectr('#fromUserSelector3', {
    defaultSelected: false,
    placeholder: 'Select a User...'
  } );

  let appViewData = [
    {
      text: "CPM Analytics®",
      value: 'historical2'
    },
    {
      text: "CPM Monitoring®",
      value: 'assurance'
    },
    {
      text: "Workspace Insights",
      value: 'rooms'
    }
  ];


  self.fromAppSelctr = new Selectr('#fromAppSelector3', {
    allowDeselect: true,
    clearable: true,
    defaultSelected: false,
    placeholder: 'Select an App ...',
    data: appViewData
  } );


  self.fromOrgSelctr.on('selectr.select', function(option) {
    self.fromUserSelctr.clear();
    self.fromUserSelctr.removeAll();

    self.fromAppSelctr.clear();
    self.fromAppSelctr.reset(); // technically I don't need to do this, but it make loading easier

    DashboardService.fetchUsersForOrgTemp(self.fromOrgSelctr.getValue()).then(users => {
      _.forEach(users, user => {
        if (!user.deleted) {
          self.fromUserSelctr.add({value: user.id, text: user.id + "." + user.name})
        }
      })
    });
  });

  self.fromUserSelctr.on('selectr.select', function(option) {
    self.fromAppSelctr.clear();
    self.fromAppSelctr.reset(); // technically I don't need to do this, but it make loading easier
  });


  // self.fromAppSelctr.on('selectr.select', function(option) {
  //   let appView = self.fromAppSelctr.getValue();
  //   let appViewArray = appView.split('/');
  // });

  self.saveCallback = null;

}

ClearPreferencesAdv.prototype.show = function (model) {
  var self = this;

  if (!_.has(model, 'appId')) {
    throw new Error('ClearPreferencesAdv needs a model with an appId.');
  }
// not sure if I need any of these to pre-populate the advanced dialog entries
  self.appId = model.appId;
  // self.viewId = model.viewId;
  self.currentOrgId = model.currentOrgId;
  self.currentUserId = model.currentUserId;

  self.saveCallback = model.saveCallback;
  self.updateError(null);

  // not super efficient resetting and reloading all data, but works for now
  self.fromOrgSelctr.clear();
  self.fromOrgSelctr.removeAll();
  self.fromUserSelctr.clear();
  self.fromUserSelctr.removeAll();

  self.fromAppSelctr.clear();
  self.fromAppSelctr.reset();


  DashboardService.fetchAllOrgsTemp().then(orgs => {
    _.forEach(orgs, org => {
      if (!org.deleted) {
        self.fromOrgSelctr.add({value: org.id, text: org.id + "." + org.name})
      }
    })
  });


  // DashboardService.fetchUsersForCurrentOrgTemp().then(users => {
  //   _.forEach(users, user => {
  //     if (!user.deleted) {
  //       self.toUsersSelctr.add({value: user.id, text: user.name})
  //     }
  //   })
  // });
  //
};

ClearPreferencesAdv.prototype.save = function () {
  let self = this;

  let fromAppViews = self.fromAppSelctr.getValue();

  let from = { orgId: Number(self.fromOrgSelctr.getValue()), users: self.fromUserSelctr.getValue().map(Number),       appIds: fromAppViews};
  console.log("Clear Preferences for "+ JSON.stringify(from));

  self.updateError('');
  PreferenceService.clearPreferencesAdv(from).then(function () {
    // if you have cleared your own preferences for the app you are in, reload the page
    if (from.orgId === self.currentOrgId && _.includes(from.users, self.currentUserId) && _.includes(from.appIds, self.appId) ) {
      window.location.reload();
    }
  })
  .catch(function (e) {
    console.error(e);
    self.updateError('There was an error clearing preferences.');
  });

  if (!self.hasUpdateError()) {
    self.signals.closeModal.dispatch();
    if (self.saveCallback) self.saveCallback();
  }
};

ClearPreferencesAdv.prototype.dispose = function () {
  let self = this;
  self.signals.onShow.dispose();
  self.signals.onSave.dispose();
};

export default {viewModel: ClearPreferencesAdv, template: templateMarkup};
